import React, { Component } from 'react';


class RegistrationBenefits extends Component {

  render() {
    return (
      <div className="col-md-5 col-sm-5 offset-md-c1">
        <p className="title_benefit">Beneficios de registrarse</p>
        <ul className="list_benefit">
          <li>Compra más rápido en tus siguientes visitas.</li>
          <li>Guarda tus distintas direcciones.</li>
          <li>Asegura tus datos e información de pago.</li>
          <li>Revisa el hisgtorial de tus compras.</li>
          <li>Dale seguimiento a tus pedidos.</li>
          <li>Recordaremos tu próximo cumpleaños.</li>
          <li>Obten 10% de descuento en tu primer dia de compra por internet con tu tarjeta Liverpool.</li>
          <li>Haz tus compras por internet de manera rápida y segura.</li>
          <li>Bloqueo de tarjeta(s) de crédito Liverpool por robo o extraviío</li>
        </ul>
      </div>
    );
  }
}

export default RegistrationBenefits;
